import type ArrayProxy from '@ember/array/proxy';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type Store from '@ember-data/store';
import type AnnouncementTemplateModel from 'garaje/models/announcement-template';
import type AnnouncementTemplateCategoryModel from 'garaje/models/announcement-template-category';
import type AnnouncementTemplateLocationModel from 'garaje/models/announcement-template-location';
import type StateService from 'garaje/services/state';

export interface EmergencyResponseIncidentTemplatesModel {
  announcementTemplates: ArrayProxy<AnnouncementTemplateModel>;
  announcementTemplateCategories: ArrayProxy<AnnouncementTemplateCategoryModel>;
  announcementTemplateLocations: ArrayProxy<AnnouncementTemplateLocationModel>;
}

export default class EmergencyResponseIncidentTemplatesRoute extends Route {
  @service declare store: Store;
  @service declare state: StateService;

  async model(): Promise<EmergencyResponseIncidentTemplatesModel> {
    const [announcementTemplates, announcementTemplateCategories, announcementTemplateLocations] = await Promise.all([
      this.loadAnnouncementTemplates(),
      this.loadAnnouncementTemplateCategories(),
      this.loadAnnouncementTemplateLocations(),
    ]);

    return {
      announcementTemplates,
      announcementTemplateCategories,
      announcementTemplateLocations,
    };
  }

  async loadAnnouncementTemplates(): Promise<ArrayProxy<AnnouncementTemplateModel>> {
    return await this.store.findAll('announcement-template', { reload: true });
  }

  async loadAnnouncementTemplateCategories(): Promise<ArrayProxy<AnnouncementTemplateCategoryModel>> {
    return await this.store.findAll('announcement-template-category', { reload: true });
  }

  async loadAnnouncementTemplateLocations(): Promise<ArrayProxy<AnnouncementTemplateLocationModel>> {
    return await this.store.findAll('announcement-template-location', { reload: true });
  }
}
